import Close from "../../../../../../Icons/Close";
import React, { useRef, useEffect, useState } from "react";
import Webcam from "react-webcam";
import Img from "react-image";
import _ from "lodash";
import "react-html5-camera-photo/build/css/index.css";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import LongPressable from "react-longpressable";
import srcIconVideo from "../../../../../../styles/img/icon-video.svg";
import srcIconVideoBreak from "../../../../../../styles/img/icon-video-pause.svg";
import srcIconPhoto from "../../../../../../styles/img/icon-photo.svg";
import srcIconVideoDownload from "../../../../../../styles/img/icon-video-download.svg";
import srcIconVideoSwitch from "../../../../../../styles/img/icon-video-switch.svg";
import iconValider from "../../../../../../styles/img/icon-check-white.svg";
import { capturedData } from "../../../../../../modules/kids/kids-list/communaute/Communaute.duck";
import { connect } from "react-redux";
import { styles } from "../../../../../../ReactConst";
import { StyleRoot } from "radium";
import { streamVideo } from "../../../../../../modules/kids/kids-list/communaute/Communaute.duck";
const IconPhoto = () => (
  <object
    data={srcIconPhoto}
    type="image/svg+xml"
    style={{
      width: "50px",
      height: "50px",
      pointerEvents: "none",
      cursor: "pointer",
    }}
    className="img-fluid"
  />
);

const IconVideoSwitch = () => (
  <object
    data={srcIconVideoSwitch}
    type="image/svg+xml"
    style={{
      width: "50px",
      height: "50px",
      pointerEvents: "none",
      cursor: "pointer",
    }}
    className="img-fluid"
  />
);

const CameraComponent = (props) => {
  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [capturing, setCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);
  const [screenshot, setScreenshot] = useState("");
  const [longPress, setLongPress] = useState(false);
  const [videoConstraints, setVideoConstraints] = useState({
    width: 1280,
    height: 720,
    facingMode: "user",
  });
  const [styleFadeIn, setFadeIn] = useState(true);
  const [timeLeft, setTimeLeft] = useState(20);
  const mounted = useRef();

  const handleClick = (event) => {
    event.preventDefault();
    setRecordedChunks([]);
    const imageSrc = webcamRef.current.getScreenshot();
    let base64Image = imageSrc.split(";base64,").pop();
    const blob = b64toBlob(base64Image, "image/png");
    setScreenshot(blob);
    props.capturedData(blob);
    props.capturedOrdonnance(blob);
  };

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const handleUpload = React.useCallback(() => {
    streamVideo(recordedChunks);
    if (recordedChunks.length > 0) {
    }
  }, [recordedChunks]);

  if (
    capturing === false &&
    Object.getOwnPropertyNames(recordedChunks).length === 0
  ) {
    handleUpload();
    props.onOpenShareVideoModale(recordedChunks);
  }
  const closeModale = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.onCloseModaleCamera();
    }, 400);
  }, []);
  return (
    <StyleRoot>
      <div
        className="modal show modal-skin modal-large modal-childunit"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="pb-4">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={closeModale}
              >
                <Close className="img-fluid" alt="" />
              </button>
            </div>
            <div className="modal-body">
              <div
                className="d-flex align-items-center justify-content-center flex-column buttons-filters"
                style={{ marginTop: "-5px" }}
              >
                <Webcam
                  audio={true}
                  height={500}
                  ref={webcamRef}
                  width={700}
                  videoConstraints={videoConstraints}
                />
              </div>

              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  paddingTop: "20px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "between",
                  marginTop: "-20px",
                }}
              >
                <button
                  style={{
                    marginLeft: "-50px",
                    borderRadius: "50%",
                    width: "80px",
                    height: "80px",
                  }}
                  className="btn-photo gradient d-flex align-items-center justify-content-center"
                  onClick={() => {
                    if (videoConstraints.facingMode === "user") {
                      const frontCamera = {
                        width: 1280,
                        height: 720,
                        facingMode: { exact: "environment" },
                      };
                      setVideoConstraints(frontCamera);
                    } else {
                      const backCamera = {
                        width: 1280,
                        height: 720,
                        facingMode: "user",
                      };
                      setVideoConstraints(backCamera);
                    }
                  }}
                >
                  <IconVideoSwitch />
                </button>

                <button
                  className="btn-photo gradient d-flex align-items-center justify-content-center bg-dark"
                  style={{
                    marginLeft: "30px",
                    borderRadius: "50%",
                    width: "80px",
                    height: "80px",
                  }}
                  onClick={handleClick}
                >
                  <IconPhoto />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
};

const mapDispatchToProps = {
  capturedData,
  streamVideo,
};
export default connect(null, mapDispatchToProps)(CameraComponent);
